import React from 'react'
import PropTypes from 'prop-types'
import { Box, Stack, Avatar, Typography, Tooltip } from '@mui/material'
import { EmailOutlined } from '@mui/icons-material'
import T from 'T'

const ContactOption = ({ props, option }) => (
  <li {...props}>
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: '100%' }}>
      <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem', bgcolor: 'primary.main' }}>{option.firstName?.charAt(0) || 'U'}</Avatar>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2">{`${option.firstName} ${option.lastName}`}</Typography>
        <Typography variant="caption" color="text.secondary">
          {option.email}
        </Typography>
      </Box>
      {option.billingNotifications && (
        <Tooltip title={T.BILLING_CONTACT}>
          <EmailOutlined fontSize="small" color="primary" />
        </Tooltip>
      )}
    </Stack>
  </li>
)

ContactOption.propTypes = {
  props: PropTypes.object.isRequired,
  option: PropTypes.object.isRequired,
}

export default ContactOption
